/* eslint-disable no-unused-vars */
// Pub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
import { i18n } from "@i18n";
import store from "@store";

// util
import {
  generateImageUrl,
  getSlideText,
  getCurSlidePageNumber,
} from "../util/gpt_addin_utils.js";

import { insertImageByCompletionUrl } from "../util/gpt_image.js";

// Office
const Office = window.Office;
const PowerPoint = window.PowerPoint;
let curPageNumber = 0;

// VSTO Host Object
import { default as hostObject_slides } from "../vsto/vsto_slides.js";
import { default as hostObject_shapes } from "../vsto/vsto_shapes.js";
const vstoMode = store.get("app/vstoMode");

export async function process_image(input) {
  publish(
    gptPubIds.pubId_Local_Gpt_ProcessingText,
    i18n.t("ppt_addin.process.text_ppt_generating_image_prompt")
  );

  // 获取Slide文本
  let allSlideText = "";
  curPageNumber = 0;
  if (vstoMode) {
    allSlideText = await hostObject_shapes.vsto_getSlideAllText(true);
    curPageNumber = await hostObject_slides.vsto_getCurPageNumber();
  } else {
    allSlideText = await getSlideText();
    curPageNumber = await getCurSlidePageNumber();
  }

  // 本地添加一条消息
  let userLogText = "";
  if (input.taskType) {
    userLogText += i18n.t("ppt_addin.message.text_userlog_format_current_page");
    userLogText = userLogText.replace(/\{0\}/g, curPageNumber + "");
    userLogText += input.taskType.title;
    if (input.taskOptions) {
      userLogText += ", ";
      userLogText += input.taskOptions.title;
    }
    userLogText += "<br />";
  }
  // 先去掉原内容，文本太长
  // if (allSlideText.length > 0) {
  //   userLogText += i18n.t(
  //     "ppt_addin.message.text_userlog_format_reference_content"
  //   );
  //   userLogText += allSlideText;
  //   userLogText += "<br />";
  // }
  if (input.text.length > 0) {
    if (input.taskType) {
      userLogText += i18n.t(
        "ppt_addin.message.text_userlog_format_your_description"
      );
    }
    userLogText += input.text;
  }
  publish(gptPubIds.pubId_Local_Addin_UserLog, userLogText);

  // 根据文本，生成图片URL
  publish(
    gptPubIds.pubId_Local_Gpt_ProcessingText,
    i18n.t("ppt_addin.process.text_ppt_generating_image")
  );
  let inputText = "";
  let pptTopic = store.get("gpt/pptTopic");
  if (pptTopic.length > 0) {
    inputText += pptTopic + "\n";
  }
  inputText = inputText + (allSlideText.length > 0 ? allSlideText : "") + input.text;
  let imageUrl = await generateImageUrl(inputText);
  console.log("Completion image url: " + imageUrl);

  if (imageUrl == null || imageUrl == "") {
    publish(gptPubIds.pubId_Local_PPT_image_generate_error, "");
    return
  }

  // 下载和插入图片
  publish(
    gptPubIds.pubId_Local_Gpt_ProcessingText,
    i18n.t("ppt_addin.process.text_ppt_generating_image_download")
  );
  let options = {
    coercionType: Office.CoercionType.Image,
    imageLeft: 480,
    imageTop: 70,
    imageWidth: 400,
    imageHeight: 400,
  };
  await insertImageByCompletionUrl(imageUrl, options);

  let logText = i18n.t("ppt_addin.process.text_ppt_generating_image_success");
  logText = logText.replace(/\{0\}/g, curPageNumber + "");
  publish(gptPubIds.pubId_Local_Addin_SystemLog, logText);
  publish(gptPubIds.pubId_Local_Aisa_AskGpt_Success, "");
  publish(gptPubIds.pubId_Local_Gpt_Processing_Success, "");
}
